import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按题材分类，快速找到您想看的韩国漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`text-xl md:text-2xl text-primary-600 group-hover:text-white transition-colors duration-300 ${
                  cat.slug === 'romance' ? 'ri-heart-line' :
                  cat.slug === 'fantasy' ? 'ri-magic-line' :
                  cat.slug === 'action' ? 'ri-sword-line' :
                  cat.slug === 'drama' ? 'ri-emotion-line' :
                  cat.slug === 'thriller' ? 'ri-search-eye-line' :
                  cat.slug === 'comedy' ? 'ri-emotion-laugh-line' :
                  cat.slug === 'horror' ? 'ri-ghost-line' :
                  'ri-calendar-line'
                }`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 mt-1 hidden sm:block">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}